import { Checkbox as HeroCheckbox } from '@heroui/react';
import classNames from 'classnames';
import type { ReactNode, Ref } from 'react';

export type Props = {
  readonly size?: 'small' | 'default';
  readonly className?: string;
  readonly name?: string;
  readonly value?: string;
  /** Accessible name when the checkbox has no visible label. */
  readonly title?: string;
  // eslint-disable-next-line react/boolean-prop-naming -- keeps the native input prop names callers already use
  readonly checked?: boolean;
  // eslint-disable-next-line react/boolean-prop-naming -- keeps the native input prop names callers already use
  readonly disabled?: boolean;
  readonly isInvalid?: boolean;
  /** The visible label; clicking it toggles the checkbox. */
  readonly children?: ReactNode;
  readonly onChange?: (checked: boolean) => void;
  readonly ref?: Ref<HTMLInputElement>;
};

const Checkbox = ({
  size = 'default',
  className,
  name,
  value,
  title,
  checked,
  disabled,
  isInvalid,
  children,
  onChange,
  ref,
}: Props) => (
  <HeroCheckbox
    className={className}
    name={name}
    value={value}
    inputRef={ref}
    isSelected={checked}
    isDisabled={disabled}
    isInvalid={isInvalid}
    aria-label={children ? undefined : title}
    onChange={onChange}
  >
    {/* Top-aligned to the label's first 20px line, so a wrapped label hangs from the box. */}
    <HeroCheckbox.Content className="items-start">
      <HeroCheckbox.Control
        className={classNames('shrink-0', size === 'small' ? 'mt-[3px] size-3.5' : 'mt-0.5')}
      >
        <HeroCheckbox.Indicator />
      </HeroCheckbox.Control>
      {children}
    </HeroCheckbox.Content>
  </HeroCheckbox>
);

export default Checkbox;
